import request from '@/utils/request';

/**
 * 认证相关 API
 */
// 获取图片验证码（返回二进制图片数据）
// GET /auth/verify-img?tempToken=xxx
export function getVerifyImg(params) {
  return request({
    url: '/auth/verify-img',
    method: 'get',
    params: {
      tempToken: params.tempToken
    },
    responseType: 'blob'
  });
}

// 登录（账号密码）
// POST /auth/login
// 参数: loginName, password, verifyCode, tempToken
export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data: {
      loginName: data.loginName || data.phone || data.username,
      password: data.password,
      verifyCode: data.verifyCode,
      tempToken: data.tempToken
    }
  });
}

// 发送验证码
export function sendSmsCode(data) {
  return request({
    url: '/auth/sms/code',
    method: 'post',
    data
  });
}

// 验证码登录
export function loginByCode(data) {
  return request({
    url: '/auth/login/code',
    method: 'post',
    data
  });
}

// 用户注册
// POST /auth/register
export function register(data) {
  return request({
    url: '/auth/register',
    method: 'post',
    data
  });
}

// 发送注册邮箱验证码
// POST /auth/register-code
export function sendEmailCode(data) {
  return request({
    url: '/auth/register-code',
    method: 'post',
    params: data
  });
}

// 登出
export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post'
  });
}

// 获取用户信息
export function getUserInfo() {
  return request({
    url: '/user/profile/detail',
    method: 'post'
  });
}

/**
 * 用户管理相关 API (与后端接口文档保持一致)
 */

// 通过手机号批量检索用户
// POST /manager/user/searchByMobiles
export function searchUsersByMobiles(mobiles) {
  return request({
    url: '/manager/user/searchByMobiles',
    method: 'post',
    data: {
      mobiles: mobiles
    }
  });
}

// 分页查询用户列表
// POST /manager/user/page
export function getUserList(params) {
  return request({
    url: '/manager/user/page',
    method: 'post',
    data: {
      pageNum: params.pageNum || params.page || 1,
      pageSize: params.pageSize || params.size || 10,
      keyword: params.keyword || undefined,
      status: params.status !== undefined && params.status !== null ? params.status : undefined,
      userType: params.userType !== undefined && params.userType !== null ? params.userType : undefined,
      orderByList: params.orderByList || undefined
    }
  });
}

// 查询用户详情
// POST /manager/user/detail
export function getUserDetail(id) {
  return request({
    url: '/manager/user/detail',
    method: 'post',
    data: { id }
  });
}

// 创建用户
// POST /manager/user/create
export function createUser(data) {
  return request({
    url: '/manager/user/create',
    method: 'post',
    data: {
      email: data.email,
      loginName: data.loginName,
      mobile: data.mobile,
      password: data.password,
      username: data.username,
      userType: data.userType
    }
  });
}

// 更新用户
// POST /manager/user/update
// 必填：id, email, mobile(^1[3-9]\d{9}$), username
export function updateUser(id, data) {
  return request({
    url: '/manager/user/update',
    method: 'post',
    data: {
      id: id,
      email: data.email,
      mobile: data.mobile,
      username: data.username,
      userType: data.userType
    }
  });
}

// 删除用户
// POST /manager/user/delete
export function deleteUser(id) {
  return request({
    url: '/manager/user/delete',
    method: 'post',
    data: { id }
  });
}

// 重置用户密码
// POST /manager/user/resetPassword
export function resetPassword(userId, data) {
  return request({
    url: '/manager/user/resetPassword',
    method: 'post',
    data: {
      userId: userId,
      newPassword: data.password || data.newPassword
    }
  });
}

// 锁定用户
// POST /manager/user/lock
export function lockUser(id) {
  return request({
    url: '/manager/user/lock',
    method: 'post',
    data: { id }
  });
}

// 解锁用户
// POST /manager/user/unlock
export function unlockUser(id) {
  return request({
    url: '/manager/user/unlock',
    method: 'post',
    data: { id }
  });
}

// 强制踢出用户
// POST /manager/user/kickOut
export function kickoutUser(id) {
  return request({
    url: '/manager/user/kickOut',
    method: 'post',
    data: { id }
  });
}

// 计算非管理员用户剩余文字数总和
// POST /manager/user/sum-remaining-words
export function sumRemainingWords() {
  return request({
    url: '/manager/user/sum-remaining-words',
    method: 'post'
  });
}

// ==================== 找回密码相关 API ====================

// 发送找回密码验证码
// POST /auth/find-pwd-code
// 同时校验账号与邮箱绑定关系，无论是否存在统一返回成功提示
export function sendFindPwdCode(data) {
  return request({
    url: '/auth/find-pwd-code',
    method: 'post',
    data: {
      loginName: data.loginName,
      email: data.email
    }
  });
}

// 找回密码-重置密码
// POST /auth/find-pwd-reset
export function findPwdReset(data) {
  return request({
    url: '/auth/find-pwd-reset',
    method: 'post',
    data: {
      loginName: data.loginName,
      email: data.email,
      verifyCode: data.verifyCode,
      newPassword: data.newPassword
    }
  });
}

/**
 * 以下接口在后端接口文档中不存在，保留但会提示用户
 */

// 充值积分 - 后端接口不存在，需要后端实现
export function rechargePoints(id, data) {
  console.warn('充值积分接口在后端接口文档中不存在，需要后端实现');
  // 返回一个模拟的 Promise，实际使用时需要后端提供接口
  return Promise.resolve({
    code: 0,
    data: null,
    message: '充值积分功能需要后端提供接口'
  });
}

// 设置可用模型 - 后端接口不存在，需要后端实现
export function setUserModels(id, data) {
  console.warn('设置可用模型接口在后端接口文档中不存在，需要后端实现');
  // 返回一个模拟的 Promise，实际使用时需要后端提供接口
  return Promise.resolve({
    code: 0,
    data: null,
    message: '设置可用模型功能需要后端提供接口'
  });
}

// 锁定/解锁用户（兼容旧接口，根据状态判断调用 lock 或 unlock）
export function toggleUserLock(id, data) {
  // 后端 status: 0-停用，1-启用
  // 如果目标是启用(1)，则调用解锁；如果目标是停用(0)，则调用锁定
  const targetStatus = data.status;
  if (targetStatus === 1 || targetStatus === 'active') {
    return unlockUser(id);
  } else {
    return lockUser(id);
  }
}

/**
 * 违规词管理相关 API
 */
// 分页查询违规词列表
export function getBannedWordList(params) {
  return request({
    url: '/manager/bannedWord/page',
    method: 'post',
    data: {
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 10,
      word: params.word || '',
      status: params.status !== undefined ? params.status : null
    }
  });
}

// 查询所有启用的违规词列表
export function getAllEnabledBannedWords() {
  return request({
    url: '/manager/bannedWord/listAll',
    method: 'post'
  });
}

// 创建违规词
export function createBannedWord(data) {
  return request({
    url: '/manager/bannedWord/create',
    method: 'post',
    data: {
      word: data.word,
      replaceWord: data.replaceWord || ''
    }
  });
}

// 更新违规词
export function updateBannedWord(data) {
  return request({
    url: '/manager/bannedWord/update',
    method: 'post',
    data: {
      id: data.id,
      word: data.word,
      replaceWord: data.replaceWord,
      status: data.status
    }
  });
}

// 删除违规词
export function deleteBannedWord(id) {
  return request({
    url: '/manager/bannedWord/delete',
    method: 'post',
    data: { id }
  });
}

// 启用违规词
export function enableBannedWord(id) {
  return request({
    url: '/manager/bannedWord/enable',
    method: 'post',
    data: { id }
  });
}

// 停用违规词
export function disableBannedWord(id) {
  return request({
    url: '/manager/bannedWord/disable',
    method: 'post',
    data: { id }
  });
}

/**
 * 字典管理相关 API
 */
// ==================== 字典类型管理 ====================

// 分页查询字典类型列表
export function getDictTypeList(params) {
  return request({
    url: '/manager/dictType/page',
    method: 'post',
    data: {
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 10,
      dictType: params.dictType || '',
      dictName: params.dictName || '',
      status: params.status !== undefined ? params.status : null
    }
  });
}

// 查询字典类型详情
export function getDictTypeDetail(id) {
  return request({
    url: '/manager/dictType/detail',
    method: 'post',
    data: { id }
  });
}

// 创建字典类型
export function createDictType(data) {
  return request({
    url: '/manager/dictType/create',
    method: 'post',
    data: {
      dictType: data.dictType,
      dictName: data.dictName,
      remark: data.remark || ''
    }
  });
}

// 更新字典类型
export function updateDictType(data) {
  return request({
    url: '/manager/dictType/update',
    method: 'post',
    data: {
      id: data.id,
      dictType: data.dictType,
      dictName: data.dictName,
      remark: data.remark,
      status: data.status
    }
  });
}

// 删除字典类型
export function deleteDictType(id) {
  return request({
    url: '/manager/dictType/delete',
    method: 'post',
    data: { id }
  });
}

// 启用字典类型
export function enableDictType(data) {
  return request({
    url: '/manager/dictType/enable',
    method: 'post',
    data: { id: data.id }
  });
}

// 停用字典类型
export function disableDictType(data) {
  return request({
    url: '/manager/dictType/disable',
    method: 'post',
    data: { id: data.id }
  });
}

// 根据字典类型查询字典值列表
export function getDictValuesByType(dictType) {
  return request({
    url: '/common/dict',
    method: 'post',
    data: { dictType }
  });
}

// ==================== 字典值管理 ====================

// 分页查询字典值列表
export function getDictValueList(params) {
  return request({
    url: '/manager/dictValue/page',
    method: 'post',
    data: {
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 10,
      dictType: params.dictType,
      dictLabel: params.dictLabel || '',
      status: params.status !== undefined ? params.status : null
    }
  });
}

// 查询字典值详情
export function getDictValueDetail(id) {
  return request({
    url: '/manager/dictValue/detail',
    method: 'post',
    data: { id }
  });
}

// 创建字典值
export function createDictValue(data) {
  return request({
    url: '/manager/dictValue/create',
    method: 'post',
    data: {
      dictType: data.dictType,
      dictLabel: data.dictLabel,
      dictValue: data.dictValue,
      sortOrder: data.sortOrder || 0,
      remark: data.remark || ''
    }
  });
}

// 更新字典值
export function updateDictValue(data) {
  return request({
    url: '/manager/dictValue/update',
    method: 'post',
    data: {
      id: data.id,
      dictType: data.dictType,
      dictLabel: data.dictLabel,
      dictValue: data.dictValue,
      sortOrder: data.sortOrder,
      remark: data.remark,
      status: data.status
    }
  });
}

// 删除字典值
export function deleteDictValue(id) {
  return request({
    url: '/manager/dictValue/delete',
    method: 'post',
    data: { id }
  });
}

// 启用字典值
export function enableDictValue(data) {
  return request({
    url: '/manager/dictValue/enable',
    method: 'post',
    data: { id: data.id }
  });
}

// 停用字典值
export function disableDictValue(data) {
  return request({
    url: '/manager/dictValue/disable',
    method: 'post',
    data: { id: data.id }
  });
}

/**
 * AI 模型管理相关 API
 */
export {
  getModelList,
  getModelDetail,
  createModel,
  updateModel,
  enableModel,
  disableModel,
  deleteModel,
  getAllModels,
  getEnabledModelList,
  getModelPage,
  getCommonModel,
  authorizeModelApi,
  getModelFactoryList,
  getModelListNoPage,
  getModelApiKeyList,
  addModelApiKey,
  verifyModelApiKey,
  deleteModelApiKey
} from './model';

/**
 * 作品管理相关 API
 */
export {
  getWorkList,
  createWork,
  updateWork,
  deleteWork,
  uploadWorkCover,
  pinWork,
  unpinWork,
  getFolderList,
  createFolder,
  updateFolder,
  deleteFolder,
  getWorkDetail,
  getChapterList,
  getChapterSimpleList,
  getChapterDetail,
  getChapterDetailSummary,
  createChapter,
  insertChapter,
  updateChapterContent,
  deleteChapter,
  renameChapter,
  updateChapterSummary,
  aiWrite,
  executeAiWriteStream,
  followUpStream,
  regenerateStream,
  getWorkExtraCount,
  getWorkLead,
  getWorkOutline,
  getWorkIntro,
  saveWorkLead,
  saveWorkOutline,
  saveWorkIntro
} from './work';

/**
 * 提示词管理相关 API
 */

// ==================== 用户侧提示词 ====================

// /**
//  * 用户侧-分页查询提示词列表
//  * @param {Object} params - 查询参数
//  * @param {number} params.writeType - 写作类型 1-AI写作 2-AI扩写润色（必填）
//  * @param {number} [params.creativeId] - 创意ID（用于创意中心细分）
//  * @param {string} [params.category] - 分类
//  * @param {string} [params.genre] - 体裁
//  * @param {string} [params.title] - 提示词标题（模糊搜索）
//  * @param {Array} [params.orderByList] - 排序参数列表 [{ field: 'heat', operator: 'desc' }]
//  * @param {number} [params.pageNum] - 页码
//  * @param {number} [params.pageSize] - 每页条数
//  * @returns {Promise}
//  */
// export function getPromptPage(params) {
//   return request({
//     url: '/user/prompt/page',
//     method: 'post',
//     data: {
//       writeType: params.writeType || 1,
//       creativeId: params.creativeId || undefined,
//       genre: params.genre || undefined,
//       title: params.title || undefined,
//       orderByList: params.orderByList || [],
//       pageNum: params.pageNum || 1,
//       pageSize: params.pageSize || 20
//     }
//   });
// }

/**
 * 用户侧-查看提示词详情
 * @param {Object} params - 查询参数
 * @param {number} params.id - 提示词ID
 * @returns {Promise}
 */
export function userPromptDetail(params) {
  return request({
    url: '/user/prompt/detail',
    method: 'post',
    data: { id: params.id }
  });
}

/**
 * 用户侧-分页查询常用提示词列表
 * @param {Object} params - 查询参数
 * @param {number} params.writeType - 写作类型 1-AI写作 2-AI扩写润色（必填）
 * @param {number} [params.creativeId] - 创意ID（用于创意中心细分）
 * @param {string} [params.category] - 分类
 * @param {string} [params.genre] - 体裁
 * @param {string} [params.title] - 提示词标题（模糊搜索）
 * @param {Array} [params.orderByList] - 排序参数列表
 * @param {number} [params.pageNum=1] - 页码
 * @param {number} [params.pageSize=20] - 每页条数
 * @returns {Promise}
 */
export function getCommonPromptPage(params) {
  return request({
    url: '/user/prompt/common',
    method: 'post',
    data: {
      writeType: params.writeType || 1,
      writeKind: params.writeKind || undefined,
      genre: params.genre || undefined,
      title: params.title || undefined,
      orderByList: params.orderByList || [],
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 20
    }
  });
}

/**
 * 用户侧-分页查询当前用户已购的提示词
 * @param {Object} params - 查询参数
 * @param {number} params.writeType - 写作类型 1-AI写作 2-AI扩写润色（必填）
 * @param {number} [params.creativeId] - 创意ID（用于创意中心细分）
 * @param {string} [params.category] - 分类
 * @param {string} [params.genre] - 体裁
 * @param {string} [params.title] - 提示词标题（模糊搜索）
 * @param {Array} [params.orderByList] - 排序参数列表
 * @param {number} [params.pageNum=1] - 页码
 * @param {number} [params.pageSize=20] - 每页条数
 * @returns {Promise}
 */
export function getPurchasedPromptPage(params) {
  return request({
    url: '/user/prompt/private',
    method: 'post',
    data: {
      writeType: params.writeType || 1,
      writeKind: params.writeKind || undefined,
      genre: params.genre || undefined,
      title: params.title || undefined,
      orderByList: params.orderByList || [],
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 20
    }
  });
}

/**
 * 用户侧-分页查询当前用户创建的提示词
 * @param {Object} params - 查询参数
 * @param {string} [params.category] - 分类
 * @param {number} [params.creativeId] - 创意
 * @param {number} [params.creator] - 创建人
 * @param {string} [params.genre] - 体裁
 * @param {Array} [params.orderByList] - 排序参数列表
 * @param {number} [params.pageNum=1] - 页码
 * @param {number} [params.pageSize=20] - 每页条数
 * @param {number} [params.status] - 状态：0-禁用 1-启用
 * @param {string} [params.title] - 提示词标题（模糊搜索）
 * @returns {Promise}
 */
export function getCreatorPromptPage(params) {
  return request({
    url: '/user/prompt/creator',
    method: 'post',
    data: {
      writeKind: params.writeKind || undefined,
      creator: params.creator || undefined,
      genre: params.genre || undefined,
      orderByList: params.orderByList || [],
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 20,
      status: params.status !== undefined ? params.status : undefined,
      title: params.title || undefined
    }
  });
}

/**
 * 用户侧-创建提示词
 * @param {Object} data - 创建参数
 * @param {string} data.title - 提示词标题
 * @param {string} data.category - 分类
 * @param {string} [data.genre] - 体裁
 * @param {string} data.content - 提示词内容
 * @param {string} [data.remark] - 使用说明
 * @param {Array} [data.fields] - 灵活字段列表
 * @param {number} [data.visibility] - 是否公开：0-公开 1-私有
 * @returns {Promise}
 */
export function createPrompt(data) {
  return request({
    url: '/user/prompt/create',
    method: 'post',
    data: {
      title: data.title,
      genre: data.genre || undefined,
      content: data.content,
      remark: data.remark || '',
      fields: data.fields || [],
      visibility: data.visibility !== undefined ? data.visibility : 0
    }
  });
}

/**
 * 用户侧-推荐提示词
 * @param {Object} data
 * @param {string} data.promptId - 提示词ID
 * @returns {Promise}
 */
export function recommendPrompt(data) {
  return request({
    url: '/user/prompt/recommend',
    method: 'post',
    data: {
      promptId: data.promptId
    }
  });
}

/**
 * 用户侧-取消推荐提示词
 * @param {Object} data
 * @param {string} data.promptId - 提示词ID
 * @returns {Promise}
 */
export function cancelRecommendPrompt(data) {
  return request({
    url: '/user/prompt/recommend/cancel',
    method: 'post',
    data: {
      promptId: data.promptId
    }
  });
}

// ==================== 管理侧提示词 ====================

// 获取提示词分类列表
// POST /dict/prompt-category
/**
 * @returns {Promise<Object>} 返回 Map<int, string> 格式的分类数据
 */
export function getPromptCategory() {
  return request({
    url: '/dict/prompt-category',
    method: 'post'
  });
}

// 获取提示词体裁列表
// POST /dict/prompt-genre
/**
 * @returns {Promise<Object>} 返回 Map<int, string> 格式的体裁数据
 */
export function getPromptGenre() {
  return request({
    url: '/dict/prompt-genre',
    method: 'post'
  });
}

// 分页查询提示词列表
// POST /manager/prompt/page
/**
 * @param {Object} params - 查询参数
 * @param {number} [params.pageNum=1] - 页码
 * @param {number} [params.pageSize=10] - 每页条数
 * @param {string} [params.category] - 分类
 * @param {string} [params.genre] - 体裁
 * @param {string} [params.platform] - 平台
 * @param {string} [params.title] - 提示词标题（模糊搜索）
 * @param {number} [params.status] - 状态：0-禁用 1-启用
 * @param {Array} [params.orderByList] - 排序参数列表
 * @returns {Promise}
 */
export function promptPage(params) {
  return request({
    url: '/manager/prompt/page',
    method: 'post',
    data: {
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 10,
      genre: params.genre || undefined,
      platform: params.platform || undefined,
      title: params.title || undefined,
      status: params.status !== undefined ? params.status : undefined,
      visibility: params.visibility !== undefined ? params.visibility : undefined,
      orderByList: params.orderByList || undefined
    }
  });
}

// 查询提示词详情
// POST /manager/prompt/detail
export function promptDetail(id) {
  return request({
    url: '/manager/prompt/detail',
    method: 'post',
    data: id
  });
}



// 创建提示词
// POST /manager/prompt/create
/**
 * @param {Object} data - 创建参数
 * @param {string} data.title - 提示词标题
 * @param {string} data.category - 分类
 * @param {string} data.genre - 体裁
 * @param {string} data.content - 提示词内容
 * @param {string} data.remark - 使用说明
 * @param {string} data.author - 创作者
 * @param {string} [data.authorAvatar] - 创作者头像URL
 * @param {string} [data.platform] - 平台
 * @param {string} [data.feature] - 特色标签
 * @param {number} [data.status] - 状态：0-禁用 1-启用
 * @param {number} [data.top] - 是否置顶：0-否 1-是
 * @returns {Promise}
 */
export function promptCreate(data) {
  return request({
    url: '/manager/prompt/create',
    method: 'post',
    data
  });
}

// 更新提示词
// POST /manager/prompt/update
export function promptUpdate(data) {
  return request({
    url: '/manager/prompt/update',
    method: 'post',
    data
  });
}

// 删除提示词
// POST /manager/prompt/delete
export function promptDelete(id) {
  return request({
    url: '/manager/prompt/delete',
    method: 'post',
    data: { id }
  });
}

/**
 * 启用提示词
 * @param {Object} data - 请求参数
 * @param {number|string} data.id - 提示词 ID
 * @returns {Promise}
 */
export function promptEnable(data) {
  return request({
    url: '/manager/prompt/enable',
    method: 'post',
    data
  });
}

/**
 * 停用提示词
 * @param {Object} data - 请求参数
 * @param {number|string} data.id - 提示词 ID
 * @returns {Promise}
 */
export function promptDisable(data) {
  return request({
    url: '/manager/prompt/disable',
    method: 'post',
    data
  });
}

// 分页查询提示词已分配用户列表
// POST /manager/prompt/user/page
export function promptUserPage(params) {
  return request({
    url: '/manager/prompt/user/page',
    method: 'post',
    data: {
      promptId: params.promptId,
      keyword: params.keyword,
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 10
    }
  });
}

// 查询可授权用户列表（未授权的用户）
// POST /manager/prompt/user/available
export function promptAvailableUsers(params) {
  return request({
    url: '/manager/prompt/user/available',
    method: 'post',
    data: {
      promptId: params.promptId,
      keyword: params.keyword,
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 10
    }
  });
}

// 分配用户到提示词
// POST /manager/prompt/user/assign
export function promptAssignUsers(data) {
  return request({
    url: '/manager/prompt/user/assign',
    method: 'post',
    data: {
      promptId: data.promptId,
      userIds: data.userIds,
      expireTime: data.expireTime !== undefined ? data.expireTime : data.expireDays
    }
  });
}

// 移除提示词的用户分配
// POST /manager/prompt/user/remove
export function promptRemoveUser(data) {
  return request({
    url: '/manager/prompt/user/remove',
    method: 'post',
    data: {
      id: data.id,
      promptId: data.promptId
    }
  });
}

// 批量分配提示词给多个用户
// POST /manager/prompt/user/batchAssign
export function promptBatchAssignUsers(data) {
  return request({
    url: '/manager/prompt/user/batchAssign',
    method: 'post',
    data: {
      promptIds: data.promptIds,
      userIds: data.userIds,
      expireTime: data.expireTime
    }
  });
}

// 批量移除提示词的用户授权
// POST /manager/prompt/user/batchRemove
export function promptBatchRemoveUsers(data) {
  return request({
    url: '/manager/prompt/user/batchRemove',
    method: 'post',
    data: {
      promptIds: data.promptIds,
      userId: data.userId
    }
  });
}

// 查询用户已授权的提示词列表
// POST /manager/prompt/user/promptPage
export function getUserAuthorizedPrompts(params) {
  return request({
    url: '/manager/prompt/user/promptPage',
    method: 'post',
    data: {
      userId: params.userId,
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 100
    }
  });
}

// 为单个用户变更授权时长
// POST /manager/prompt/user/renew
export function promptRenewUser(data) {
  return request({
    url: '/manager/prompt/user/renew',
    method: 'post',
    data: {
      id: data.id,
      promptId: data.promptId,
      days: data.days
    }
  });
}

/**
 * 算力商品管理相关 API
 */

// 分页查询算力商品列表
// POST /manager/product/page
/**
 * @param {Object} params - 查询参数
 * @param {number} [params.pageNum=1] - 页码
 * @param {number} [params.pageSize=10] - 每页条数
 * @param {string} [params.productName] - 商品名称（模糊查询）
 * @param {number} [params.status] - 商品状态：0-不可售卖 1-上架 2-下架
 * @param {Array} [params.orderByList] - 排序参数列表
 * @returns {Promise}
 */
export function getProductList(params) {
  return request({
    url: '/manager/product/page',
    method: 'post',
    data: {
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 10,
      productName: params.productName || undefined,
      status: params.status !== undefined ? params.status : undefined,
      orderByList: params.orderByList || undefined
    }
  });
}

// 创建算力商品
// POST /manager/product/create
/**
 * @param {Object} data - 创建参数
 * @param {string} data.productName - 商品名称（必填）
 * @param {number} data.computeAmount - 充值算力数量（必填）
 * @param {number} data.price - 原价（分）（必填）
 * @param {number} [data.actualPrice] - 现价（分）
 * @param {number} [data.giftAmount] - 赠送算力数量
 * @param {number} [data.hasDiscount] - 有无折扣 0-无 1-有
 * @param {number} [data.discountRate] - 折扣率（如80表示8折）
 * @param {string} [data.discountStartTime] - 折扣开始时间
 * @param {string} [data.discountEndTime] - 折扣结束时间
 * @param {number} [data.hasGift] - 有无赠送 0-无 1-有
 * @param {string} [data.giftStartTime] - 赠送开始时间
 * @param {string} [data.giftEndTime] - 赠送结束时间
 * @returns {Promise}
 */
export function createProduct(data) {
  return request({
    url: '/manager/product/create',
    method: 'post',
    data
  });
}

// 删除算力商品
// POST /manager/product/delete
/**
 * @param {number} id - 商品ID
 * @returns {Promise}
 */
export function deleteProduct(id) {
  return request({
    url: '/manager/product/delete',
    method: 'post',
    data: { id }
  });
}

// 查询商品详情
// POST /manager/product/detail
/**
 * @param {number} id - 商品ID
 * @returns {Promise}
 */
export function getProductDetail(id) {
  return request({
    url: '/manager/product/detail',
    method: 'post',
    data: { id }
  });
}

// 上架商品
// POST /manager/product/onShelf
/**
 * @param {number} id - 商品ID
 * @returns {Promise}
 */
export function onlineProduct(id) {
  return request({
    url: '/manager/product/onShelf',
    method: 'post',
    data: { id }
  });
}

// 下架商品
// POST /manager/product/offShelf
/**
 * @param {number} id - 商品ID
 * @returns {Promise}
 */
export function offlineProduct(id) {
  return request({
    url: '/manager/product/offShelf',
    method: 'post',
    data: { id }
  });
}

// 查询商品变更历史
// POST /manager/product/history
/**
 * @param {Object} params - 查询参数
 * @param {number} params.productId - 商品ID（必填）
 * @param {number} [params.pageNum=1] - 页码
 * @param {number} [params.pageSize=10] - 每页条数
 * @param {number} [params.operationType] - 操作类型：1-创建 2-修改 3-上架 4-下架
 * @param {string} [params.startDate] - 开始时间
 * @param {string} [params.endDate] - 结束时间
 * @returns {Promise}
 */
export function getProductChangePage(params) {
  return request({
    url: '/manager/product/history',
    method: 'post',
    data: {
      productId: params.productId,
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 10,
      operationType: params.operationType !== undefined ? params.operationType : undefined,
      startDate: params.startDate || undefined,
      endDate: params.endDate || undefined
    }
  });
}

// 生成激活码
// POST /manager/product/generateVoucher
/**
 * @param {Object} params - 生成参数
 * @param {number} params.productId - 商品ID（必填）
 * @param {number} params.quantity - 生成数量（必填）
 * @param {number} params.payPrice - 实付价（分）（必填）
 * @param {number} params.version - 版本号（必填）
 * @returns {Promise}
 */
export function generateVoucher(params) {
  return request({
    url: '/manager/product/generateVoucher',
    method: 'post',
    data: {
      productId: params.productId,
      quantity: params.quantity,
      payPrice: params.payPrice,
      version: params.version
    }
  });
}

// 直充
// POST /manager/product/directPay
/**
 * @param {Object} params - 直充参数
 * @param {number} params.productId - 商品ID（必填）
 * @param {number} params.userId - 充值目标用户ID（必填）
 * @param {number} params.quantity - 充值数量（必填）
 * @param {number} params.payPrice - 实付价（分）（必填）
 * @param {number} params.version - 版本号（必填）
 * @returns {Promise}
 */
export function directPay(params) {
  return request({
    url: '/manager/product/directPay',
    method: 'post',
    data: {
      productId: params.productId,
      userId: params.userId,
      quantity: params.quantity,
      payPrice: params.payPrice,
      version: params.version
    }
  });
}

// 复制激活码
// POST /manager/product/copyVoucher
/**
 * @param {number} id - 激活码列表ID（售卖记录ID）
 * @returns {Promise<Object>} 返回 Map<string, string> 结构的数据
 */
export function copyVoucher(id) {
  return request({
    url: '/manager/product/copyVoucher',
    method: 'post',
    data: { id }
  });
}

// 更新算力商品
// POST /manager/product/update
/**
 * @param {Object} data - 更新参数
 * @param {number} data.id - 商品ID（必填）
 * @param {string} data.productName - 商品名称
 * @param {number} data.computeAmount - 充值算力数量
 * @param {number} data.price - 原价（分）
 * @param {number} [data.actualPrice] - 现价（分）
 * @param {number} [data.giftAmount] - 赠送算力数量
 * @param {number} [data.hasDiscount] - 有无折扣 0-无 1-有
 * @param {number} [data.discountRate] - 折扣率（如80表示8折）
 * @param {string} [data.discountStartTime] - 折扣开始时间
 * @param {string} [data.discountEndTime] - 折扣结束时间
 * @param {number} [data.hasGift] - 有无赠送 0-无 1-有
 * @param {string} [data.giftStartTime] - 赠送开始时间
 * @param {string} [data.giftEndTime] - 赠送结束时间
 * @returns {Promise}
 */
export function updateProduct(data) {
  return request({
    url: '/manager/product/update',
    method: 'post',
    data
  });
}

/**
 * 获取上架商品列表（用户端）
 * POST /common/product/list
 */
export function getProductOnShelfList() {
  return request({
    url: '/common/product/list',
    method: 'post'
  });
}

// 分页查询购买清单
// POST /manager/product/sale
/**
 * @param {Object} params - 查询参数
 * @param {number} [params.pageNum=1] - 页码
 * @param {number} [params.pageSize=10] - 每页条数
 * @param {number} [params.userId] - 购买用户ID
 * @param {number} [params.productId] - 商品ID
 * @param {number} [params.saleType] - 售卖形式：1-直充 2-券码
 * @param {number} [params.redeemed] - 是否核销：0-未核销 1-已核销
 * @param {string} [params.voucherCode] - 券号（精确查询）
 * @param {Array} [params.orderByList] - 排序参数列表
 * @returns {Promise}
 */
export function getProductSalePage(params) {
  return request({
    url: '/manager/product/sale',
    method: 'post',
    data: {
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 10,
      userId: params.userId !== undefined ? params.userId : undefined,
      productId: params.productId !== undefined ? params.productId : undefined,
      saleType: params.saleType !== undefined ? params.saleType : undefined,
      redeemed: params.redeemed !== undefined ? params.redeemed : undefined,
      startDate: params.startDate || undefined,
      endDate: params.endDate || undefined,
      voucherCode: params.voucherCode || undefined,
      orderByList: params.orderByList || undefined
    }
  });
}

// 分页查询用户充值列表（用户管理专用）
// POST /manager/user/recharge-page
/**
 * @param {Object} params - 查询参数
 * @param {number} params.userId - 用户ID（必填）
 * @param {number} [params.pageNum=1] - 页码
 * @param {number} [params.pageSize=10] - 每页条数
 * @param {number} [params.saleType] - 售卖形式：1-直充 2-券码
 * @param {string} [params.startDate] - 开始时间
 * @param {string} [params.endDate] - 结束时间
 * @param {Array} [params.orderByList] - 排序参数列表
 * @returns {Promise}
 */
export function getUserRechargePage(params) {
  return request({
    url: '/manager/user/recharge-page',
    method: 'post',
    data: {
      userId: params.userId,
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 10,
      saleType: params.saleType || undefined,
      startDate: params.startDate || undefined,
      endDate: params.endDate || undefined,
      orderByList: params.orderByList || undefined
    }
  });
}

// 获取售卖/充值形式
// POST /dict/sale-type
/**
 * @returns {Promise}
 */
export function getSaleType() {
  return request({
    url: '/dict/sale-type',
    method: 'post'
  });
}

// 获取算力使用-业务类型字典列表
// POST /dict/biz-type
/**
 * @returns {Promise}
 */
export function getBizType() {
  return request({
    url: '/dict/biz-type',
    method: 'post'
  });
}

// 分页查询算力消费明细
// POST /manager/compute/record/page
/**
 * @param {Object} params - 查询参数
 * @param {number} [params.pageNum=1] - 页码
 * @param {number} [params.pageSize=10] - 每页条数
 * @param {number} [params.userId] - 用户ID
 * @param {string} [params.bizType] - 业务类型（如：AI_CHAT、AI_DRAW）
 * @param {number} [params.type] - 变动类型：1-充值 2-赠送 3-消耗 4-冻结 5-解冻返还 6-失败返还
 * @param {string} [params.startTime] - 开始时间
 * @param {string} [params.endTime] - 结束时间
 * @param {Array} [params.orderByList] - 排序参数列表
 * @returns {Promise}
 */
export function getComputeRecordPage(params) {
  return request({
    url: '/manager/compute/record/page',
    method: 'post',
    data: {
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 10,
      userId: params.userId !== undefined ? params.userId : undefined,
      bizType: params.bizType || undefined,
      type: params.type !== undefined ? params.type : undefined,
      startTime: params.startTime || undefined,
      endTime: params.endTime || undefined,
      orderByList: params.orderByList || undefined
    }
  });
}

/**
 * 通过手机号检索用户
 * POST /manager/user/searchByMobile
 * @param {string} mobile - 手机号
 * @returns {Promise<Object>} 用户列表
 */
export function searchByMobile(mobile) {
  return request({
    url: '/manager/user/searchByMobile',
    method: 'post',
    data: {
      mobiles: mobile
    }
  });
}

/**
 * 创意模板管理相关 API
 */

// ==================== 管理侧创意模板 ====================

// 分页查询创意模板列表
// POST /manager/creative/page
export function getCreativePage(params) {
  return request({
    url: '/manager/creative/page',
    method: 'post',
    data: {
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 10,
      title: params.title || undefined,
      status: params.status !== undefined && params.status !== null ? params.status : undefined
    }
  });
}

// 查询创意模板详情
// POST /manager/creative/detail
export function getCreativeDetail(id) {
  return request({
    url: '/manager/creative/detail',
    method: 'post',
    data: { id }
  });
}

// 创建创意模板
// POST /manager/creative/create
export function createCreative(data) {
  return request({
    url: '/manager/creative/create',
    method: 'post',
    data: {
      title: data.title,
      description: data.description || '',
      content: data.content,
      sortOrder: data.sortOrder || 0,
      coverImage: data.coverImage || '',
      supportMemo: data.supportMemo || 0,
      supportWork: data.supportWork || 0,
      supportChapter: data.supportChapter || 0,
      fields: data.fields || []
    }
  });
}

// 更新创意模板
// POST /manager/creative/update
export function updateCreative(data) {
  return request({
    url: '/manager/creative/update',
    method: 'post',
    data: {
      id: data.id,
      title: data.title,
      description: data.description || '',
      content: data.content,
      sortOrder: data.sortOrder || 0,
      coverImage: data.coverImage || '',
      supportMemo: data.supportMemo || 0,
      supportWork: data.supportWork || 0,
      supportChapter: data.supportChapter || 0,
      fields: data.fields || []
    }
  });
}

// 删除创意模板
// POST /manager/creative/delete
export function deleteCreative(id) {
  return request({
    url: '/manager/creative/delete',
    method: 'post',
    data: { id }
  });
}

// 启用创意模板
// POST /manager/creative/enable
export function enableCreative(data) {
  return request({
    url: '/manager/creative/enable',
    method: 'post',
    data: { id: data.id }
  });
}

// 停用创意模板
// POST /manager/creative/disable
export function disableCreative(data) {
  return request({
    url: '/manager/creative/disable',
    method: 'post',
    data: { id: data.id }
  });
}

// ==================== 用户侧创意模板 ====================

// 用户侧-分页查询创意模板列表
// POST /user/creative/list
export function getCreativeList() {
  return request({
    url: '/user/creative/list',
    method: 'post',
    data: {}
  });
}

// 管理侧-查询创意模板列表（不分页）
// POST /manager/creative/list
export function getCreativeListNoPage(params) {
  return request({
    url: '/manager/creative/list',
    method: 'post',
    data: {
      title: params.title || undefined
    }
  });
}

// ==================== 备忘录相关 API ====================

export {
  createMemo,
  getMemoList,
  getMemoDetail,
  getMemoFolderList
} from './memo';

// ==================== 系统配置相关 API ====================

export {
  getMailConfig,
  saveMailConfig,
  testMailConnect
} from './sysConfig';

/**
 * AI 写作管理管理相关 API
 */
export {
  getAiDefaultPromptList,
  getAiDefaultPromptAvailableKinds,
  createAiDefaultPrompt,
  getAiDefaultPromptDetail,
  updateAiDefaultPrompt,
  deleteAiDefaultPrompt,
  restoreAiDefaultPrompt,
  getAiDefaultPromptHistoryList
} from './aiDefaultPrompt';

/**
 * AI 写作记录相关 API
 */
export {
  getAiWriteRecordPage,
  getAiWriteRecordDetail,
  getAiWriteRecordHistory
} from './aiChat';

/**
 * 通用上传相关 API
 */

/**
 * 上传图片文件
 * @param {File} file - 图片文件（支持 JPG、PNG、GIF、WebP）
 * @returns {Promise<Object>} 上传结果，返回 { fileName, fileUrl }
 */
export function uploadImage(file) {
  const formData = new FormData();
  formData.append('file', file);
  return request({
    url: '/common/upload-image',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

/**
 * 常用语管理相关 API
 */
export {
  createCommonPhrase,
  deleteCommonPhrase,
  listAllCommonPhrases,
  pageCommonPhrases,
  sortCommonPhrases,
  updateCommonPhrase
} from './user';
